import { type CSSProperties } from "react";
import { cn } from "utils";

export interface ColorDotProps {
  shape?: "square" | "round";
  ring?: boolean;
  className?: string;
  style?: CSSProperties;
}

export const ColorDot = ({
  shape = "square",
  ring = false,
  className,
  style,
}: ColorDotProps) => (
  <span
    aria-hidden
    style={style}
    className={cn(
      "inline-block h-2 w-2 shrink-0",
      shape === "round" ? "rounded-full" : "rounded-xs",
      ring && "ring-1 ring-white/45",
      className,
    )}
  />
);
